import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import { Spinner, Select } from '../'

export class SelectIdentityByResponsibility extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    responsibility: PropTypes.string.isRequired,
    exclude: PropTypes.arrayOf(PropTypes.string),
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  }

  loadOptions = () => {
    let identitiesToDisable = this.props.disable
    let identitiesToExclude = this.props.exclude || []
    let options = []
    this.props.data.responsibilities.edges.forEach(({ node: option }, i) => {
      if (identitiesToExclude.indexOf(option.identity.id) === -1) {
        options.push(
          {
            label: `${option.identity.firstName} ${option.identity.lastName}`,
            value: option.identity.id,
            disabled: identitiesToDisable
              ? identitiesToDisable.indexOf(option.identity.id) > -1
                ? true
                : false
              : false
          }
        )
      }
    })

    if (!this.props.noDefaultOption) {
      options.unshift(
        <option key='default' value={null}></option>
      )
    }

    return options
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' size='small' />
    }

    let value = this.props.value ? this.props.value : undefined
    let options = this.loadOptions()

    return (
      <Select
        label={this.props.label}
        value={value}
        onChange={this.props.onChange}
        hasError={this.props.hasError}
        disabled={this.props.disabled}
        options={options}
      />
    )
  }
}

const getIdentitiesByResponsibility = gql`query($responsibility: String!) {
  responsibilities(description_Icontains: $responsibility, orderBy: "identity__first_name") {
    edges {
      node {
        id
        identity {
          id
          firstName
          lastName
        }
      }
    }
  }
}
`

export const withData =
  graphql(getIdentitiesByResponsibility, {
    options: ({ responsibility }) => ({
      variables: { responsibility }
    })
  })

export default withData(SelectIdentityByResponsibility)



// WEBPACK FOOTER //
// ./src/components/select-identity-by-responsibility/index.js